import { create } from 'zustand'
import { useUserStore } from '@/src/common/store/useUserStore'
import type { ExpoRouter } from 'expo-router'

/** @see {@link https://github.com/microsoft/TypeScript/issues/29729#issuecomment-505826972} */
type AccountCreationStep = ExpoRouter.__routes['href'] | undefined

interface IUseAccountCreationStore {
  setAccountCreationStep: (accountCreationStep: AccountCreationStep) => void
  /**
   * The current screen/step that the user is at in the account creation process
   */
  accountCreationStep: AccountCreationStep
  clearAccountCreationStep: () => void
}

export const useAccountCreationStore = create<IUseAccountCreationStore>((set) => ({
  accountCreationStep: undefined,
  setAccountCreationStep: (accountCreationStep) => set({ accountCreationStep }),
  clearAccountCreationStep: () => set({ accountCreationStep: undefined }),
}))

// eslint-disable-next-line @typescript-eslint/no-deprecated
useUserStore.subscribe(
  (state) => state.userInformation?.phoneNumber,
  function handleUserInformation(phoneNumber) {
    if (phoneNumber) {
      const { setAccountCreationStep } = useAccountCreationStore.getState()
      setAccountCreationStep(undefined)
    }
  },
)
